module.exports = __webpack_public_path__ + "static/media/10.4bc368b7.svg";